import "./incentive.scss"
import "./static/incentive-desktop.png"
import "./static/incentive-mobile.png"
import "./static/incentive-desktop.webp"
import "./static/incentive-mobile.webp"
import { showSignup } from "components/signup"

declare global {
  interface Window {
    FCGON?: {
      logged_in?: boolean
    }
  }
}

function signupOptionsFor(form: HTMLFormElement) {
  const data = new FormData(form)
  const initialOffer = data.get("incentive_offer")
  const options: { initialOffer?: string; initialStep?: string } = {}

  if (typeof initialOffer === "string") {
    options.initialOffer = initialOffer
  }
  if (window.FCGON && window.FCGON.logged_in) {
    options.initialStep = "the-payment"
  }

  return options
}

function initIncentiveOffers(root: ParentNode = document) {
  const forms = Array.from(root.querySelectorAll<HTMLFormElement>(".js-incentive-offers"))

  forms.forEach((form) => {
    if (form.dataset.incentiveInitialized) return

    form.setAttribute("data-incentive-initialized", "true")
    form.addEventListener("submit", (event) => {
      event.preventDefault()
      showSignup(signupOptionsFor(form))
    })
  })
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initIncentiveOffers())
} else {
  initIncentiveOffers()
}
